import { ButtonGroup, Stack } from '@chakra-ui/react';

import { Form } from '@packages/chakra-v3';
import type { RegisterFormType } from '../../schemas';

type RegisterFormProps = {
	onClickBack: () => void;
};

const RegisterForm = ({ onClickBack }: RegisterFormProps) => {
	return (
		<Stack gap={8}>
			<Form.TextInput<RegisterFormType> label={'Email'} name={'email'} />
			<Form.TextInput<RegisterFormType> label={'Name'} name={'name'} />
			<Form.DateInput<RegisterFormType> label={'Birthday'} name={'dateOfBirth'} />
			<Form.TextInput<RegisterFormType> label={'Phone Number'} name={'phoneNumber'} />
			<Form.PasswordInput<RegisterFormType> label={'Password'} name={'password'} />
			<Form.PasswordInput<RegisterFormType> label={'Confirm Password'} name={'confirmPassword'} />
			<ButtonGroup gap={12} w={'100%'}>
				<Form.Button flex={1} onClick={onClickBack}>Back</Form.Button>
				<Form.SubmitButton flex={1}>Register</Form.SubmitButton>
			</ButtonGroup>
		</Stack>

	);
};

export default RegisterForm;